/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  BatchControllerBulkCreateV1PathParameters,
  BatchControllerDeleteV1PathParameters,
  BatchControllerDownloadFactoryFileV1PathParameters,
  BatchControllerFindAllV1Params,
  BatchControllerFindAllV1PathParameters,
  BulkCreateBatchDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class BatchesService {
  private readonly http = inject(HttpClient);
  /**
   * Get all batches
   * @summary List all batches
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: BatchControllerFindAllV1PathParameters,
    params?: BatchControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/batches`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Bulk create devices inventory in a batch
   */

  bulkCreate<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: BatchControllerBulkCreateV1PathParameters,
    bulkCreateBatchDto: BulkCreateBatchDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/batches`, bulkCreateBatchDto);
  }
  /**
   * Generate and download factory file JSON for batch inventory items
   * @summary Download factory file JSON by batch
   */

  downloadFactoryFile<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    batchId,
  }: BatchControllerDownloadFactoryFileV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/batches/${batchId}/download`);
  }
  /**
   * Delete a batch and all its inventory items
   * @summary Delete batch
   */

  delete<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, batchId }: BatchControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/batches/${batchId}`);
  }
}
